export default [
  {
    name: "APP_API_CALL_SUCCESS",
    callback: function(response) {
      this.$refs.progressDialog.close();

      if (this.$store.state.app.autoopen) {
        this.$refs.modalOutputDialog.openWith(response.data.log);
      }
    }
  },
  {
    name: "APP_API_CALL_FAILED",
    callback: function(err) {
      this.$refs.progressDialog.close();
      this.$refs.errorDialog.open("Communication error", err);
    }
  },
  {
    name: "APP_API_CALL_ERROR",
    callback: function(err) {
      this.$refs.progressDialog.close();
      this.$refs.errorDialog.open("Communication error", err);
    }
  },
  {
    name: "APP_API_NO_TERMS",
    callback: function(err) {
      this.$refs.progressDialog.close();
      this.$refs.errorDialog.open("Game not created", "No terms found with such criteria or server offline", err);
    }
  },
  {
    name: "APP_API_CALL_STARTED",
    callback: function() {
      // console.log("APP_API_CALL_STARTED");
      this.$refs.progressDialog.open();
    }
  }
];
